import { render, staticRenderFns } from "./CopyrightPolicy.vue?vue&type=template&id=641e886d&"
import script from "./CopyrightPolicy.vue?vue&type=script&lang=js&"
export * from "./CopyrightPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CopyrightPolicy.vue"
export default component.exports